import React, { useEffect, useState } from 'react';
import { Alert, Card, List, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { CompanyAdminGate } from './CompanyAdminGate';
import { companyAdminError, loadCompanyTrees } from './companyAdminApi';

const { Title, Text } = Typography;

const ModelsBody: React.FC<{ companyId: string; companyName: string }> = ({ companyId, companyName }) => {
  const [trees, setTrees] = useState<Array<{ id?: string; name?: string }>>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    loadCompanyTrees(companyId)
      .then((rows) => {
        if (!cancelled) setTrees(rows);
      })
      .catch((err) => {
        if (!cancelled) {
          setTrees([]);
          setError(companyAdminError(err, 'Could not load artifact trees for this company.'));
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [companyId]);

  return (
    <Card>
      <Title level={3}>Models</Title>
      <Text type="secondary">
        Artifact trees for {companyName}. The platform artifact tree manager remains a separate cross-tenant tool.
      </Text>
      {error ? <Alert style={{ marginTop: 16 }} type="error" showIcon message={error} /> : null}
      <List
        style={{ marginTop: 16 }}
        loading={loading}
        dataSource={trees}
        locale={{ emptyText: loading ? 'Loading' : 'No artifact trees for this company.' }}
        renderItem={(tree) => (
          <List.Item>
            <Link to="/artifacts">{tree.name || tree.id || 'Untitled tree'}</Link>
          </List.Item>
        )}
      />
    </Card>
  );
};

export const CompanyAdminModelsPage: React.FC = () => (
  <CompanyAdminGate>
    {(target) => <ModelsBody companyId={target.companyId} companyName={target.companyName} />}
  </CompanyAdminGate>
);

export default CompanyAdminModelsPage;
